// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__17GOD","title":"Header_title__34eSL","side":"Header_side__2oi0T"};